import { call, put } from 'redux-saga/effects'
import { getDataAll as apiGetDataAll } from 'api/Api'
import {
  setUnreadCount,
  setCardCounts
} from '../redux/notifications'

export default function * fetchUnreadNotificationsCount (action) {
  const [
    { Value: unreadCount },
    { Counts }
  ] = yield call(apiGetDataAll, [
    { method: 'MyNotificationsUnreadCount' },
    { method: 'UnreadCardActivitiesCount' }
  ])

  // Card unread counts
  let countsByCardId = {}

  Counts.forEach(Count => {
    countsByCardId[Count.Id] = Count.C
  })

  yield put([
    setUnreadCount({
      unreadCount: unreadCount
    }),
    setCardCounts({
      countsByCardId
    })
  ])
}
